import { Component, OnInit, Input, EventEmitter, Output, OnDestroy } from '@angular/core';
import { HeaderService } from '../tools/header.service';
import { Router } from '@angular/router';
import { SideMenuComponent } from '../sideMenu/sideMenu.component';
import { StorageService } from '../tools/storage.service';
import { Utils } from '../tools/utils';
import { Language } from '../entities/Language';
import { Roles } from '../tools/api.service';

@Component({
  selector: 'nav-bar',
  templateUrl: './nav-bar.component.html',
  styleUrls: ['./nav-bar.component.scss']
})
export class NavBarComponent implements OnInit, OnDestroy {

  @Input() title: string;
  @Input() logo: string;
  @Input() displayGoToTopButton: boolean;
  @Input() goToTopButtonOpacity: string;
  @Input() sidenavOpened: boolean;
  @Output() public sidenavToggle = new EventEmitter();

  canBack: boolean = false;
  private back: boolean = false;
  private canBackSub: any;
  private backSub: any;
  private roleSub: any;
  private logoSub: any;
  private titleSub: any;
  private nbProductSub: any;
  private productsSub: any;
  private cartBtnSub: any;
  Utils = Utils;
  isExpanded: boolean = false;
  role: Roles = Roles.Unknown;
  nbProduct: number;
  shoppingCart: boolean = false;
  productsStr: any;
  products: any;
  cartBtnEnabled: boolean;
  private langue: Language;
  private langueSub: any;

  totalAmount = 0;

  constructor(private headerService: HeaderService, private router: Router) { }

  ngOnInit() {
    this.langueSub = this.headerService.currentLangue.subscribe(langue => {
      this.langue = langue;
    });
    this.titleSub = this.headerService.currentTitle.subscribe(title => this.title = title);
    this.logoSub = this.headerService.currentLogo.subscribe(logo => this.logo = logo);
    this.canBackSub = this.headerService.currentCanBack.subscribe(canBack => this.canBack = canBack);
    this.backSub = this.headerService.currentBack.subscribe(back => this.back = back);
    this.roleSub = this.headerService.currentRole.subscribe(role => this.role = role);
    this.nbProductSub = this.headerService.currentNbProduct.subscribe(nbProduct => this.nbProduct = nbProduct);
    this.productsSub = this.headerService.currentProducts.subscribe(products => this.productsStr = products);
    this.cartBtnSub = this.headerService.currentCartBtnEnabled.subscribe(btnEnabled => this.cartBtnEnabled = btnEnabled);
  }

  ngOnDestroy(): void {
    if (this.titleSub != null) this.titleSub.unsubscribe();
    if (this.backSub != null) this.backSub.unsubscribe();
    if (this.logoSub != null) this.logoSub.unsubscribe();
    if (this.canBackSub != null) this.canBackSub.unsubscribe();
    if (this.roleSub != null) this.roleSub.unsubscribe();
    if (this.nbProductSub != null) this.nbProductSub.unsubscribe();
    if (this.productsSub != null) this.productsSub.unsubscribe();
    if (this.cartBtnSub != null) this.cartBtnSub.unsubscribe();
    if (this.langueSub != null) this.langueSub.unsubscribe();
  }

  toggleCart() {
    // Pour dérouler le panier actuel
    this.products = JSON.parse(this.productsStr);
    if (this.products != null && this.products.length > 0) {
      this.cartBtnEnabled = true;
      this.totalAmount = 0;
      this.products.forEach((element: any) => {
        this.totalAmount += element.tPrice;
      });
    } else {
      this.products = [];
      this.totalAmount = 0;
      this.cartBtnEnabled = false;
    }
    // Effet de toggle
    if (this.shoppingCart) {
      this.shoppingCart = false;
    } else {
      this.shoppingCart = true;
    }
  }

  previous() {
      if (this.router.url == "/equinox" || this.router.url == "/colorwebtech" || this.router.url == "/colorbook")
      this.headerService.changeBack(true);
    else {
      if (this.router.url == "/panier")
        this.router.navigate(["/catalogue"]);
      else
        window.history.back();
    }
  }

  public onToggleSidenav = () => {
    this.sidenavToggle.emit();
  }

  scrollTop() {
    document.querySelector('#topanchor').scrollIntoView({behavior: 'smooth'});
  }

}
